import { render, staticRenderFns } from "./OneTimeRide.vue?vue&type=template&id=3c2bdf36&scoped=true"
import script from "./OneTimeRide.vue?vue&type=script&lang=js"
export * from "./OneTimeRide.vue?vue&type=script&lang=js"
import style0 from "./OneTimeRide.vue?vue&type=style&index=0&id=3c2bdf36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2bdf36",
  null
  
)

export default component.exports